import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const syncSession = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `pay-bridge/sessions/${args?.id}/sync`,
      method: 'post',
      authorization: true,
      config: {
        showErr: false,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

export default { syncSession }
